export default "__VITE_ASSET__PCS27Cnf__"